import { MutOpt } from '@/app/api';
import { queryClient } from '@/lib/query-client';
import { createQueryKeys } from '@/lib/query-factory';
import { queryOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import * as api from './accounts.api';

const keys = createQueryKeys('accounts');

export const accountQueries = {
  keys,
  list: () =>
    queryOptions({
      queryKey: keys.list(),
      queryFn: () => api.fetchAccounts(),
    }),
  detail: (id: number) =>
    queryOptions({
      queryKey: keys.detail(id),
      queryFn: () => api.fetchAccount(id),
      enabled: !!id,
    }),
};

export const accountMutations = {
  update: (): MutOpt<typeof api.updateAccount> => ({
    mutationFn: api.updateAccount,
    onSuccess: (_, { recnum }) => {
      queryClient.invalidateQueries({ queryKey: keys.detail(recnum) });
      queryClient.invalidateQueries({ queryKey: keys.lists() });
      toast.success('Account updated');
    },
    onError: (error: Error) => {
      toast.error('Failed to update account', {
        description: error.message,
      });
    },
  }),
};
